var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94351 11.9093H12.0508C12.4708 11.9093 12.7326 11.4565 12.5253 11.0911L7.46896 2.3638C7.42146 2.28058 7.3528 2.21141 7.26993 2.1633C7.18707 2.11519 7.09296 2.08984 6.99714 2.08984C6.90132 2.08984 6.80721 2.11519 6.72435 2.1633C6.64149 2.21141 6.57282 2.28058 6.52532 2.3638L1.46896 11.0911C1.26169 11.4565 1.52351 11.9093 1.94351 11.9093V11.9093ZM7.54532 10.2729H6.45441V9.18198H7.54532V10.2729ZM6.99987 8.09107C6.69987 8.09107 6.45441 7.84562 6.45441 7.54562V6.45471C6.45441 6.15471 6.69987 5.90925 6.99987 5.90925C7.29987 5.90925 7.54532 6.15471 7.54532 6.45471V7.54562C7.54532 7.84562 7.29987 8.09107 6.99987 8.09107Z",
    fill: "#F3F9F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.689caf3020908cf4c1d4279fd1a76623.svg";
export { ForwardRef as ReactComponent };